export interface ConsentDialogProps {
  doctorId: number;
  prescriberEmail?: string;
  prescriptionId?: number;
  onClose?: () => void;
}

export interface ConsentDialogState {
  isVisible: boolean;
  isLoading: boolean;
  email: string;
  emailError: string | null;
  apiError: string | null;
  isSubmitting: boolean;
}

export interface ConsentDialogUIProps {
  isVisible: boolean;
  email: string;
  emailError: string | null;
  apiError: string | null;
  isSubmitting: boolean;
  onEmailChange: (email: string) => void;
  onAccept: () => void;
  onRefuse: () => void;
  onClose: () => void;
}

export interface UseConsentDialogReturn {
  state: ConsentDialogState;
  actions: {
    handleEmailChange: (email: string) => void;
    handleAccept: () => Promise<void>;
    handleRefuse: () => Promise<void>;
    handleClose: () => Promise<void>;
  };
}

export interface ConsentVerificationResponse {
  RequererConsentimento: boolean;
  DataAceite?: string;
  TipoConsentimento: string;
  TextoConsentimento?: string;
}

export interface ConsentSubmissionPayload {
  TipoConsentimento: 'Opt_In';
  TextoConsentimento: string;
  TermoAceite: boolean;
  Contato?: string;
}

export interface PrescriberUpdatePayload {
  email: string;
}

export const ERROR_MESSAGES = {
  VALIDATION: {
    EMAIL_REQUIRED: 'E-mail é obrigatório',
    EMAIL_INVALID: 'E-mail inválido',
  },
  API: {
    CONSENT_SUBMISSION: 'Erro ao registrar consentimento. Tente novamente.',
    EMAIL_UPDATE: 'Erro ao atualizar e-mail. Tente novamente.',
    NETWORK: 'Verifique sua conexão e tente novamente.',
    GENERIC: 'Ocorreu um erro. Tente novamente.',
  },
} as const;

export const CONSENT_TEXT = 
  'Receba e-mails sobre mudanças regulatórias, dicas de uso e lançamentos para não ficar desatualizado. Não enviamos spam. Cancelar quando quiser.' as const;

export const CONSENT_TYPE = 'Opt_In' as const;

export const DIALOG_DISPLAY_DELAY = 3000 as const;

export const CONSENT_DIALOG_EVENTS = {
  DIALOG_DISPLAYED: 'consent_dialog_displayed',
  USER_ACCEPTED: 'consent_dialog_accepted',
  USER_REFUSED: 'consent_dialog_refused',
  ERROR_OCCURRED: 'consent_dialog_error',
} as const;
